export enum VehicleType {
  USED = 'used',
  NEW = 'new',
  ALL = 'all',
}
